import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection, NamedProperty } from "sprint-common-web";

import { GetFramerateProfilesLookupResponse } from "../../api/orders-api/framerate-profile/responses/GetFramerateProfilesLookupResponse";
import { useFramerateProfilesApi } from "../../api/orders-api/framerate-profile/useFramerateProfilesApi";
import { FramerateProfile, mapToFramerateProfile } from "../../types/FramerateProfile";

interface IFramerateProfilesDataContext {
    framerateProfiles: NamedProperty[];
    isLoading: boolean;
}

export const FramerateProfilesDataContext = createContext<IFramerateProfilesDataContext>({
    framerateProfiles: [],
    isLoading: true
});

type FramerateProfilesDataProviderProps = React.PropsWithChildren<unknown>;

export const FramerateProfilesDataProvider: React.FunctionComponent<FramerateProfilesDataProviderProps> = ({
    children
}: FramerateProfilesDataProviderProps) => {
    const [framerateProfiles, setFramerateProfiles] = useState<FramerateProfile[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getFramerateProfilesLookup } = useFramerateProfilesApi();

    useEffect(() => {
        setIsLoading(true);

        getFramerateProfilesLookup()
            .then((response: GetFramerateProfilesLookupResponse) => {
                const framerateProfileList = response.items.map(mapToFramerateProfile);
                const sortedItems = getSortedCollection(framerateProfileList, "name");

                setFramerateProfiles(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <FramerateProfilesDataContext.Provider value={{ framerateProfiles, isLoading }}>
            {children}
        </FramerateProfilesDataContext.Provider>
    );
};
